import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["id", "name", "onChange", "checked", "onClick", "disabled"]
const _hoisted_2 = ["for"]


export default /*#__PURE__*/_defineComponent({
  __name: 'RadioGroup',
  props: {
    isChecked: {
        type: Boolean,
        default: false,
    },
    isDisabled: {
        type: Boolean,
        default: false,
    },
    modelValue: {
        default: null,
        required: true,
    },
    options: {
        type: Array,
    },
    name: {
        type: String,
    },
    labelClass: {
        type: String,
    },
    customClass: {
        type: String,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option, index) => {
    return (_openBlock(), _createElementBlock("div", {
      key: index,
      class: _normalizeClass(["flex items-center", __props.customClass])
    }, [
      _createElementVNode("input", {
        id: `${option.id}-${__props.name}`,
        name: __props.name,
        type: "radio",
        class: "cursor-pointer h-5 w-5 text-primary-500 border-primary-200 border-2 focus:ring-0 focus:ring-offset-0 focus:outline-0 focus:outline-offset-0 checked:border-primary-500",
        onChange: ($event: any) => (_ctx.$emit('update:modelValue', option.value)),
        checked: __props.modelValue == option.value,
        onClick: ($event: any) => (_ctx.$emit('update', option.value)),
        disabled: option.available_slots == 0 || option.is_blocked || __props.isDisabled
      }, null, 40, _hoisted_1),
      _createElementVNode("label", {
        style: _normalizeStyle(option.available_slots == 0 || option.is_blocked || __props.isDisabled ? 'opacity: .2' : ''),
        for: `${option.id}-${__props.name}`,
        class: _normalizeClass(["ml-2 block", [__props.modelValue === option.value ? 'text-primary-600' : 'text-black', __props.labelClass]])
      }, _toDisplayString(option.label), 15, _hoisted_2)
    ], 2))
  }), 128))
}
}

})